import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Link } from 'react-router-dom';
import Backarrow from '../../Images/backarrow.png';

import { Form, Input, Row, Col,  Button, } from 'antd';
class Requestquote extends Component {
    constructor(props) {
        super(props);
        this.state = {
          firstname: "",
          lastname: "",
          companyname: "",
          address: "",
          email: "",
          phonenumber: "",
          password: "",
          city: "",
          state: "",
          zip: "",
          confirmpassword: "",
          loading: false,
          confirmDirty: false,
          autoCompleteResult: [],
        }
      }
      hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);
    render(){
        const {
            getFieldDecorator
          } = this.props.form;
        return(
            <div className="background">
             <Link to = "/app/stones"style={{marginLeft:'15%'}}><span className="back"><img src={Backarrow} alt="img" style={{paddingRight:'10px'}}/>back</span></Link> 
                <div className="requestformdiv">
                <Form onSubmit={this.handleSubmit}  >
        
        <Row>
          <h2 className="quoteheading">Request a quote</h2>
          
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">First Name</span>}>
              {getFieldDecorator('firstName', {
                rules: [{ required: true, message: 'Please input your First Name!' }],
              })(<Input placeholder="First name" setFieldsValue={this.state.firstname} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">Last Name</span>}>
              {getFieldDecorator('lastName', {
                rules: [{ required: true, message: 'Please input your Last Name!' }],
              })(<Input placeholder="Last name" setFieldsValue={this.state.lastname} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item className="Formitem" style={{width:'97.5%'}}
              label={<span className="label">Company Name</span>}>
              {getFieldDecorator('companyName', {
                rules: [{ required: true, message: 'Please input your Company Name!' }],
              })(<Input placeholder='Company name' setFieldsValue={this.state.companyname} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">Address</span>}>
              {getFieldDecorator('address', {
                rules: [{ required: true, message: 'Please input your Address!' }],
              })(<Input placeholder='123 Main Street' />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">City</span>}>
              {getFieldDecorator('city', {
                rules: [{ required: true, message: 'Please input your City!' }],
              })(<Input placeholder="New York" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">State</span>} >
              {getFieldDecorator('state', {
                rules: [{ required: true, message: 'Please input your State!' }],
              })(<Input placeholder="NY" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item className="Formitem"
              label={<span className="label">Zip</span>}>
              {getFieldDecorator('zip', {
                rules: [{ required: true, message: 'Please input your Zip!' }],
              })(<Input placeholder="00000" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row >
          <Col span={12}>
            <Form.Item className="Formitem" label={<span className="label">Contact Phone</span>}>
              {getFieldDecorator('phone', {
                rules: [{ message: 'The input is not valid contact phone!', },
                { required: true, message: 'Please input your contact phone!' }],
              })(<Input placeholder='(754)581-3996' style={{ width: '100%' }} setFieldsValue={this.state.phonenumber} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item className="Formitem" label={<span className="label">Corporate Email</span>}>
              {getFieldDecorator('email', {
                rules: [{ type: 'email', message: 'The input is not valid Corporate Email', },
                { required: true, message: 'Please input your Corporate Email!', },],
              })(<Input placeholder='mary.vargas@mail.com' autoComplete="new-password" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{marginBottom:'30px'}}>
        <Form.Item style={{width:'97.5%'}} className="Formitem" label={<span className="label">Notes</span>}>
              {getFieldDecorator('notes', {
                rules: [{ type: 'notes', message: 'enter notes', },
                { required: true, message: 'Please input your Notes', },],
              })(<Input size="large"  />)}
            </Form.Item>
            </Row> 

        
        <Form.Item className="signupbutton">
          <Button type="primary" loading={this.state.loading} htmlType="submit" className="Submit"  >
            Request a Quote
        </Button>
        </Form.Item>
        
      </Form>
                </div>
            </div>
        )
    }
}
export default Form.create({ name: 'requestquote' })(Requestquote);